let slideOption = 0;

/**
 * This function sets up the reviews slideshow.
 * @prop slideItemIndex - int
 */
function slideshow(slideItemIndex) {
    const slides = document.getElementsByClassName("reviews__slide");
    const dots = document.getElementsByClassName("reviews__dot");

    if (slides.length === 0) {
        return;
    }

    // Needed to control the slide item index.
    if (slideItemIndex >= slides.length){
        slideItemIndex = 0;
    }
    if (slideItemIndex < 0) {
        slideItemIndex = slides.length - 1;
    }

    for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }

    // Needed to make all dots unselected.
    for (let i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }

    slides[slideItemIndex].style.display = "block";

    // Needed to make the slide item's dot selected.
    dots[slideItemIndex].className += " active";

    slideOption = slideItemIndex;
}

/**
 * This function advances or regresses the slideshow.
 * @prop slideItemIndex - int
 */
function advanceOrRegressSlideshow(slideItemIndex) {
    slideshow(slideOption + slideItemIndex);
}

/**
 * This function makes the slideshow go to any slide from its index.
 * @prop slideItemIndex - int
 */
function currentSlide(slideItemIndex) {
    slideshow(slideItemIndex);
}

// Needed to hide all slides on page load.
document.addEventListener("DOMContentLoaded", () => {
    const slides = document.getElementsByClassName("reviews__slide");
    const dots = document.getElementsByClassName("reviews__dot");

    // Hides the slides.
    for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }

    // Needed to show only the first slide.
    if (slides.length > 0) {
        slides[0].style.display = "block";
        
        // Needed to select the first slide's dot.
        dots[0].className += " active";
    }

    // Initiates the slideshow cycle.
    setInterval(() => advanceOrRegressSlideshow(1), 4000);
});